import theme from './theme'
import translations from './translations'
import assets from './assets'

export { theme, translations, assets }



// WEBPACK FOOTER //
// ./src/config/index.js